import React from 'react'
import Work5 from './work/Work5'
import Work6 from './work/Work6'
import Work7 from './work/Work7'
import Work8 from './work/Work8'
export default function Slider2() {
  return (
    <div>
        <div class="">
				<div class="row portfolio-grid justify-content-center ">
				
				<div class="col-lg-4 all latest ">
					<Work5/>
				</div>
				<div class="col-lg-4 all p-3 latest">

					<Work6/>
					<Work7/>
				</div>

				<div class="col-lg-4 all latest">

          <Work8/>
				</div>
				
					
				</div>
			</div>
    </div>
  )
}
